export default __webpack_public_path__ + "static/media/copy_order.7097b141.svg";